import sound from './idle.wav';export default sound;